const passengers = {
  table: {
    headers: {
      supplier: 'Fornecedor',
    },
  },
  forms: {
    information: {
      supplier: {
        header: 'Fornecedor',
        fields: {
          label: 'Fornecedor Preferencial',
        },
      },
    },
  },
};

export default passengers;
